import Typography from "@mui/material/Typography";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";

export const Home = () => {
  return (
    <>
      <UnauthenticatedTemplate>
        <Typography variant="h6">
          Please sign-in to see outside counsel activities.
        </Typography>
      </UnauthenticatedTemplate>
      <AuthenticatedTemplate>
        {" "}
        <Typography variant="h6">Welcome to Outside Counsel</Typography>
      </AuthenticatedTemplate>
    </>
  );
};
